module.exports = __webpack_public_path__ + "static/008676-ae46cdc17b62130a218fd8d496623068.jpg";